import { memo } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { ASSET_MODAL_CLOSE } from '~/constants/testIDs';

type CloseButtonProps = {
  onClose: () => void;
};

export const CloseButton = memo(({ onClose }: CloseButtonProps) => {
  return (
    <IconButton
      adsIcon
      appearance="ghost"
      color="gray"
      data-testid={ASSET_MODAL_CLOSE}
      icon={XIcon}
      label="Close"
      onClick={onClose}
      size="medium"
    />
  );
});

CloseButton.displayName = 'CloseButton';
